import { useLocation, useNavigate } from "react-router-dom";
import './NewsPageElementCss/NewsDetailSec.css'
// import '.\NewsPageElements\NewsPageElementCss\NewsDetailSec.css'
// C:\Users\RB\Downloads\RB\RB\src\PageElements\NewsPageElements\NewsPageElementCss\NewsDetailSec.css

export default function NewsDetailPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const news = location.state?.news;

  if (!news) {
    return (
      <div className="noNewsFound">
        <h2>No news data found</h2>
        <button onClick={() => navigate(-1)}>Go Back</button>
      </div>
    );
  }
  console.log("news==>", news);

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <>
      <div className="newsDetailContainer">
        <h3 className="newsTitleInDetails">{news.Notification_Title}</h3>
        <p className="newsDate">
          Posted on{" "}
          {new Date(news.Notification_Date).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
          })}
        </p>
        <img
          src={news.Notification_Image}
          alt={news.Notification_Title}
          className="newsImage"
        />

        <p className="newsBody">{news.Notification_Body}</p>
        <p className="neweventdate">
          Event Date:{" "}
          {new Date(news.Event_Date).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
          })}
        </p>

        <div className="tagContainer">
          <p className="tag">
            <a href={news.Tag} target="_blank" rel="noopener noreferrer">
              <b> Visit Link for more info</b> : {news.Tag}
            </a>
          </p>
        </div>

        <button className="backbutton rbdButton" onClick={handleBack}><span className="btn-text">Back</span>
        </button>
      </div>
    </>
  );
}
